import React from 'react';
import {finances} from '../../actions/financesArray';

export class SelectFinance extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      selected: false,
      type: this.props.type,
      taxAvailable: false,
      subsidyAvailable: false,
      selectActive: "",
      oldRound: 0,
    };

    this.handleSelected = this.handleSelected.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  createAlert = (msg) => {
    this.props.createAlert(msg);
  }

  handleClick(e){
    e.preventDefault();

    const selected = finances.find( (current) => {return current.name === this.state.selected});

    if(this.state.selected !== false && selected !== undefined) {
      const dataForCallback = {
        name: selected.name,
        type: selected.type,
      };
      this.props.callbackPurchase(dataForCallback);
    }
  }

  handleSelected(e){
    if( e.target.value !== "false" ){
      this.setState({
        selected: e.target.value
      })
    } else {
      this.setState({
        selected: false
      })
    }
  }

  getAvailableTax = () => {
    const roundNumber = this.props.self.round;

    let taxActive = finances.filter((current) => { return current.type === "tax" && current.active === true }).length;
    return (taxActive < roundNumber ? true : false);
  }

  getAvailableSubsidy = () => {
    const roundNumber = this.props.self.round;

    let subActive = finances.filter((current) => { return current.type === "subsidy" && current.active === true }).length;
    return (subActive < roundNumber ? true : false);
  }

  getOptions = (ids) => {
    let selects = [];


    let options = finances.filter( (current) => { return current.active === false && ids.includes(current.id) } );

    if(!this.props.self.taxAvailable[this.props.self.round-1]){
      options = options.filter( (current) => { return current.type !== "tax"});
    }

    if(!this.props.self.subsidyAvailable[this.props.self.round-1]){
      options = options.filter( (current) => { return current.type !== "subsidy"});
    }

    if(options.length === 0) {
      selects.push(<option defaultValue key="_-1" val="false">Niet meer beschikbaar deze ronde</option>);
    } else {
      selects.push(<option defaultValue key="_-2" val="false">Selecteer een {this.props.typeText} om te activeren</option>);

      for (var i = 0; i < options.length; i++) {
        let current = options[i];
        selects.push(
          <option
            key={"_"+i}
            value={current.name}>
            {current.name} | {(current.type === "tax" ? "Belasting | \u20AC" + current.amount : "Subsidie | \u20AC" + current.amount + " totaal")}
          </option>
        );
      }
    }



    return selects;
  }

  getForm(){
    let inactive = false;
    if( this.props.typeText === "subsidie" && !this.props.self.subsidyAvailable[this.props.self.round-1] ){
      inactive = true;
    } else if( this.props.typeText === "belasting" && !this.props.self.taxAvailable[this.props.self.round-1] ){
      inactive = true;
    }

    return (
      <div className="row">
        <form>
          <div className="formRow">
            <label>Kies een {this.props.typeText}</label>

            <select onChange={this.handleSelected} disabled={inactive}>
              {this.getOptions(this.props.finances)}
            </select>
          </div>
          <div className="dealButton" onClick={this.handleClick} disabled={inactive}>
            <img alt="DealButton" src={require("../../assets/elements/Icon - deal.svg")}/>
            <div className="text">Pas toe</div>
          </div>
        </form>
      </div>
    );
  }

  render(){
    return this.getForm();
  }
}



// WEBPACK FOOTER //
// ./src/components/interactive/selectFinance.js